import { DatalayerService } from '@analytics/datalayer';
import { analyticsHash, AnalyticsUtils } from '@analytics/utils';
import { inject, Injectable, Injector } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { loginSuccessTrackerCookie } from '@legacy/common';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class LoginAnalyticsService {
  readonly #analyticsUtils = inject(AnalyticsUtils);
  readonly #datalayer = inject(DatalayerService);
  readonly #injector = inject(Injector);
  readonly #cookieService = inject(CookieService);

  /**
   * Pushes an event to the datalayer indicating that a successful login has taken place.
   * @param accountId account ID of logged in user.
   */
  public readonly trackLogin = async (accountId: string) => {
    const { brand, services } = this.#injector.get(ENVIRONMENT_CONFIG);
    const clientid = analyticsHash(`${brand}_${accountId}`);
    const clientname = services?.identityProvider?.clientName ?? 'unknown';

    this.#datalayer.pushEvent({
      event: 'tool-laststep',
      info: {
        name: `${this.#analyticsUtils.getSiteContextAbbreviation()} login`,
        placement: await this.#analyticsUtils.getElementPlacement('login'),
        step: 1,
        stepname: 'login laststep',
        result: {
          clientid,
          clientname,
        },
      },
    });
  };

  /**
   * checks if a cookie indicating a successful login has been done is present.
   * clears cookies if present.
   *
   * @returns boolean indicating whether or not cookies have been cleared
   */
  public clearAuthTrackingCookies = () => {
    const lengthCookieName = `${loginSuccessTrackerCookie}-length`;
    const cookieName = `${loginSuccessTrackerCookie}-0`;
    const cookie = this.#cookieService.get(cookieName);
    if (cookie === 'true') {
      this.#cookieService.delete(cookieName);
      this.#cookieService.delete(lengthCookieName);
      return true;
    }
    return false;
  };
}
